// Client for POST /v1/scout-search — the agentic replacement for the one-shot
// /v1/scout-criteria extraction when creating a search.
//
// The agent queries the real athlete pool while it works, so the criteria it
// returns are ones that actually matched something.
import { sseFetch } from "./sseFetch";

/** Spanish progress lines for the events the scout should see. */
const describe = (event, payload) => {
  if (event === "start") return "Interpretando el brief…";
  if (event === "tool_call" && payload?.tool === "search_athletes") {
    const c = payload.args || {};
    const bits = [];
    if (c.positions?.length) bits.push(c.positions.join(", "));
    if (c.age_max) bits.push(`sub-${c.age_max}`);
    if (c.regions?.length) bits.push(c.regions.join(", "));
    if (c.competition_level_min) bits.push(c.competition_level_min);
    return bits.length ? `Buscando ${bits.join(" · ")}…` : "Buscando atletas…";
  }
  if (event === "tool_result") return payload?.summary ?? null;
  return null;
};

/**
 * runScoutSearchAgent(brief, { onProgress, signal })
 *
 * Resolves with { title, criteria, shortlist, search_notes }. `onProgress` gets
 * a Spanish status line each time the agent takes a visible step.
 * Rejects with an ApiError, or an Error carrying the agent's own message when
 * the run fails after the stream has opened.
 */
export const runScoutSearchAgent = async (brief, { onProgress, signal } = {}) => {
  let result = null;
  let failure = null;

  await sseFetch("/v1/scout-search", {
    body: { brief },
    signal,
    onEvent: (event, payload) => {
      if (event === "final") result = payload?.output ?? null;
      else if (event === "error") failure = payload?.message || "El agente falló.";
      else {
        const line = describe(event, payload);
        if (line) onProgress?.(line);
      }
    },
  });

  if (failure) throw new Error(failure);
  if (!result) throw new Error("El agente no devolvió resultados.");
  return result;
};
